import { Flex, Text } from '@chakra-ui/react';
import { X } from 'lucide-react';
import * as React from 'react';

import {
  filterChipBorderRadius,
  filterChipCloseIconSize,
  filterChipGap,
  filterChipHeight,
  filterChipPaddingX,
  filterChipPaddingY,
} from './table-toolbar.kds';

export interface FilterChipProps {
  /** Filter category label (e.g. "State:"). */
  label: string;
  /** Active filter value(s) (e.g. "CA, TX, AL"). */
  value: string;
  /** Called when the remove (X) button is clicked. */
  onRemove?: () => void;
}

export const FilterChip = React.forwardRef<HTMLDivElement, FilterChipProps>(function FilterChip(props, ref) {
  const { label, value, onRemove } = props;

  return (
    <Flex
      ref={ref}
      align="center"
      justify="center"
      gap={filterChipGap}
      h={filterChipHeight}
      px={filterChipPaddingX}
      py={filterChipPaddingY}
      borderRadius={filterChipBorderRadius}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="neutral.200"
      bg="neutral.0"
      data-testid="filter-chip"
    >
      <Flex align="center" gap={filterChipGap} flexShrink={0}>
        <Text textStyle="default.regular" color="neutral.350" whiteSpace="nowrap">
          {label}
        </Text>
        <Text textStyle="default.medium" color="neutral.350" whiteSpace="nowrap">
          {value}
        </Text>
      </Flex>

      {onRemove && (
        <button
          type="button"
          aria-label={`Remove ${label} filter`}
          onClick={onRemove}
          data-testid="filter-chip-remove"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'var(--ks-colors-neutral-250)',
          }}
        >
          <X size={filterChipCloseIconSize} />
        </button>
      )}
    </Flex>
  );
});
FilterChip.displayName = 'FilterChip';
